import { get } from 'lodash-es'
import Avm from './avm'
import NoAvm from './noAvm'

export default function PropertyEstimate({
  data,
  children
}) {

  const avmData = get(data, 'avm')
  return (
    <section className='grid grid-cols-1 gap-20 md:grid-cols-[1fr,220px] xl:grid-cols-[1fr,292px]'>
      <aside className='border p-20 rounded-b-sm md:border-0 md:p-0'>
        {
          avmData
            // 有avm
            ? (
              <Avm data={data} />
            )
            : (
              <NoAvm data={data} />
            )
        }
      </aside>
      {children}
    </section>
  )
}